<template>
	<div class="health_medical_list">
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="load">
			<div class="list_item bg-white" v-for="item in list" :key="item.id" @click="clickPreview(item)">
				<van-cell class="van_cell" :title="item.recordDate" is-link title-class="cell_title"></van-cell>
				<div class="list_content">
					<p class="van-ellipsis"><span>就诊医院</span>{{ item.hospitalName || '--' }}</p>
					<p class="van-ellipsis"><span>就诊科室</span>{{ item.departmentName || '--' }}</p>
				</div>
			</div>
		</van-list>

		<foot-button>
			<van-button type="primary" block @click="clickCreate">添加就医记录</van-button>
		</foot-button>
	</div>
</template>

<script>
	export default {
		name: 'healthMedicalList',
		data: () => ({
			loading: false,
			limit: 5,
			page: 1,
			list: [],
			total: 0
		}),
		created () {
			this.load ()
		},
		computed: {
			finished () {
				return this.list.length >= this.total
			}
		},
		methods: {
			load () {
				this.loading = true
				this.$api.patient.getHospitalVisit({
					limit: this.limit,
					page: this.page,
					patientId: this.$route.params.id
				}).then(res => {
					this.loading = false
					if (!res.code) {
						this.list = [...this.list, ...res.data.list]
						this.total = res.data.total
						this.page ++
					}
				}).catch(() => this.loading = false)
			},
			clickPreview (item) {
				this.$router.push({
					path: `/health/medical/edit/${this.$route.params.id}`,
					query: {
						id: item.id
					}
				})
			},
			clickCreate () {
				this.$router.push(`/health/medical/edit/${this.$route.params.id}`)
			}
		}
	};
</script>

<style scoped lang="less">
	.health_medical_list {
		padding: 32px;
		.list_item {
			overflow: hidden;
			border-radius: 20px;
			padding: 0 32px;
			& + .list_item { margin-top: 28px; }
			.van_cell {
				padding: 32px 0;
				border-bottom: 1px solid #eee;
				&::after{ display: none; }
				.cell_title {
					font-family: PingFangSC-Medium;
					font-size: 30px;
					font-weight: 500;
					color: #1F2329;
				}
			}
			.list_content {
				padding-bottom: 32px;
				p {
					margin-top: 32px;
					height: 34px;
					font-family: PingFangSC-Regular;
					font-size: 30px;
					line-height: 34px;
					color: #1F2329;
					word-break: break-all;
					>span {
						color: #8F959E;
						padding-right: 24px;
					}
				}
			}
		}
	}
</style>
